import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/pueblo-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Pueblo", "pueblo"),
  component: () => (
    <CityDigitalMarketingPage
      city="Pueblo"
      slug="pueblo"
      intro="Pueblo is an underserved market with real growth opportunity — and very few quality digital marketing agencies serving local businesses. Colorado Web Impressions fills that gap, just 45 minutes from our Colorado Springs HQ."
      whyUs={[
        "One of the only quality agencies actively serving Pueblo businesses",
        "SEO built for Pueblo's core industries: trades, manufacturing, and services",
        "No long contracts — we earn your business every month",
      ]}
      nearby={[
        { name: "Colorado Springs", to: "/colorado-springs" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Aurora", to: "/aurora-digital-marketing" },
        { name: "Castle Rock", to: "/castle-rock" },
        { name: "Grand Junction", to: "/grand-junction-digital-marketing" },
      ]}
      testimonial={{
        quote:
          "Booked solid through the busy season. We've had to hire two more techs to keep up with the leads.",
        role: "Electrical Contractor",
        city: "Pueblo",
      }}
      industryLinks={industryLinksFor("Pueblo")}
    />
  ),
});
